/* istanbul ignore file */

function toHexChannel(channel: number): string {
    return Math.max(0, Math.min(255, Math.round(channel))).toString(16).padStart(2, '0');
}

/**
 * Lightweight RGBA color model.
 *
 * Replaces the `Color` class previously provided by
 * `@nng-components/angular-material-color-picker`. The serialized shape
 * (`{ r, g, b, a, hex, rgba, roundA }`) is preserved intentionally so that
 * app-branding / map-pin colors persisted to the API remain compatible.
 * `hex` is a 6-character, lowercase string without a leading `#`.
 */
export class Color {
    a: number;
    b: number;
    g: number;
    hex: string;
    r: number;
    rgba: string;
    roundA: number;

    constructor(r: number, g: number, b: number, a?: number) {
        const boundedAlpha = a === undefined || a === null || isNaN(a) || a < 0 || a > 1 ? 1 : a;
        this.r = Math.round(r);
        this.g = Math.round(g);
        this.b = Math.round(b);
        this.a = boundedAlpha;
        this.roundA = Math.round(100 * boundedAlpha) / 100;
        this.hex = `${toHexChannel(this.r)}${toHexChannel(this.g)}${toHexChannel(this.b)}`;
        this.rgba = `rgba(${this.r}, ${this.g}, ${this.b}, ${boundedAlpha})`;
    }

    toString(format?: string): string {
        if (format === 'hex') {
            return `#${this.hex}`;
        }
        return this.rgba;
    }
}
